type CedeIconProps = {
  width?: number;
  height?: number;
};
export const CedeIconCircle = ({ width = 22, height = 22 }: CedeIconProps) => (
  <svg width={width} height={height} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle
      cx={11}
      cy={11}
      r={9.75}
      style={{
        stroke: "#000",
        fill: "none",
      }}
    />
    {/* <circle
      cx={11}
      cy={11}
      r={10.5}
      style={{
        fill: "none",
        strokeWidth: 1,
        stroke: "#5EA6FF",
      }}
    /> */}
    <circle
      cx={11}
      cy={11}
      r={9.25}
      style={{
        strokeWidth: 0,
        stroke: "#fff",
        fill: "#fff",
      }}
    />
    <path
      fill="#000"
      d="M9.236 11.807c.828-1.435.591-3.123-.53-3.771-1.12-.647-2.701-.008-3.529 1.427-.829 1.435-.592 3.123.529 3.77 1.121.647 2.701.009 3.53-1.426Z"
    />
    <path fill="#fff" d="M8.348 10.506a.882.882 0 1 0 0-1.765.882.882 0 0 0 0 1.765Z" />
    <path
      fill="#000"
      d="M16.482 13.206c1.121-.647 1.358-2.335.529-3.77-.828-1.436-2.409-2.074-3.529-1.427-1.121.647-1.358 2.335-.53 3.77.829 1.435 2.409 2.074 3.53 1.427Z"
    />
    <path fill="#fff" d="M13.879 10.521a.882.882 0 1 0 0-1.764.882.882 0 0 0 0 1.764Z" />
    <path
      fill="#000"
      d="M11.113 14.25s-.629-.025-.855.136c-.225.162-.21.411-.21.411s-.03.255.044.421c.075.165.512.137.727.506 0 0 .197.067.294.048M11.114 14.25s.63-.025.855.136c.226.162.211.411.211.411s.03.255-.045.421c-.075.165-.512.137-.727.506 0 0-.197.067-.294.048"
    />
  </svg>
);
